<template>
  <ig-page-base
    :is-boxed="true"
    class="page-terms"
    type="large"
  >
    <vue-pdf-embed source="https://assets.integrai.com.br/contrato_termos_e_condicoes_de_uso.pdf" />
  </ig-page-base>
</template>

<script>
import Vue from 'vue';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import { IgPageBase } from '@integrai/ui';

export default Vue.extend({
  name: 'page-term-and-conditions',
  components: {
    IgPageBase,
    VuePdfEmbed,
  },
});
</script>

<style lang="scss">
.page-terms {
  width: 100%;
  h2 {
    margin-bottom: 0!important;
  }
  .box {
    padding: 0!important;
  }
}
</style>
